import moment from 'moment';

export const toDDMMYYYY = (
  dt: string | undefined,
  fromFormat = 'YYYY-MM-DD'
): string => moment(dt, fromFormat).format('DDMMYYYY');

export const toAussieStandardDateFormat = (
  date: string,
  fromFormat = 'DDMMYYYY'
): string => moment(date, fromFormat).format('DD / MM / YYYY');

export const toShortMonthFormat = (
  date: string,
  fromFormat = 'YYYY-MM-DD'
): string => moment(date, fromFormat).format('D MMM YYYY');

export const toDayOfMonthWithOrdinal = (
  date: string,
  fromFormat = 'YYYY-MM-DD'
): string => moment(date, fromFormat).format('Do');

export const toYYYYMMDD = (
  dt: string | undefined,
  fromFormat = 'DDMMYYYY'
): string => moment(dt, fromFormat).format('YYYY-MM-DD');

export const calculatePolicyExpiryDate = (policyStartDate: string): string =>
  moment(policyStartDate).add(1, 'year').format('YYYY-MM-DD');

export const addNDaysToDate = (initialDate: string, nDays: number): string =>
  moment(initialDate).add(nDays, 'day').format('DD / MM / YYYY');
